import Head from 'next/head';
import { AppProps } from 'next/app';
import { isIOS } from 'react-device-detect';

import { initializeStorage, Provider } from '@/models/Storage';

import '../styles/theme.scss';
import shareImg from '../assets/shares/share.jpg';
import shareResultImg from '../assets/shares/share_result.jpg';

import { Origin, PublicPath } from '@/utils/constant';

export default function MyApp(props: AppProps): JSX.Element {
    const { Component, pageProps, router } = props;

    const store = initializeStorage();
    // @ts-ignore
    const title = 'Лента ярких Моментов';
    const description = router.asPath.includes('/result')
        ? 'Посмотрите несколько моментов и сыграйте в «угадайку»'
        : 'Угадывайте товары в коротких роликах';

    const image = router.asPath.includes('/result') ? shareResultImg : shareImg;

    const host = process.env.NODE_ENV === 'production' ? Origin : 'http://localhost:3000';

    return (
        <>
            <Head>
                {isIOS && (
                    <meta
                        name="viewport"
                        content="width=device-width, height=device-height, initial-scale=1.0, viewport-fit=cover, maximum-scale=1"
                    />
                )}

                <base target="_blank" />

                {/* Favicon */}
                <link
                    id="favicon"
                    rel="shortcut icon"
                    href="https://cs.pikabu.ru/assets/favicon.ico"
                    type="image/x-icon"
                />
                <link
                    rel="apple-touch-icon"
                    href="https://cs.pikabu.ru/assets/images/apple-touch-icon-60x60.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="76x76"
                    href="https://cs.pikabu.ru/assets/images/apple-touch-icon-76x76.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="120x120"
                    href="https://cs.pikabu.ru/assets/images/apple-touch-icon-120x120.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="152x152"
                    href="https://cs.pikabu.ru/assets/images/apple-touch-icon-152x152.png"
                />

                <title>{title}</title>
                <meta property="og:image" content={host + image.src} />
                <meta name="twitter:image:src" content={host + image.src} />
                <link rel="image_src" href={host + image.src} />
                <meta property="og:url" content={host + PublicPath + router.asPath} />

                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Pikabu.ru" />
                <meta property="og:title" content={title} />
                <meta property="og:locale" content="ru_RU" />
                <meta property="og:description" content={description} />
                <meta property="og:image:width" content="978" />
                <meta property="og:image:height" content="504" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={title} />

                <meta name="twitter:description" content={description} />
                <meta name="twitter:image:width" content="978" />
                <meta name="twitter:image:height" content="504" />
                <meta name="twitter:domain" content="Pikabu.ru" />
            </Head>
            <Provider value={store}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: `
                <!-- Yandex.Metrika counter -->

<!-- Yandex.Metrika counter -->
<script type="text/javascript" >
   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
   m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

   ym(53131834, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
   });
</script>
<noscript><div><img src="https://mc.yandex.ru/watch/53131834" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
<!-- /Yandex.Metrika counter -->  

<script type="text/javascript">
        var _gaq = _gaq || [];
        _gaq.push(["_setAccount", "UA-28292940-1"]);
        _gaq.push(["_setDomainName", "pikabu.ru"]);
        _gaq.push(["_setAllowLinker", true]);
        _gaq.push(["_trackPageview"]);
        (function () {
                var ga = document.createElement("script"); ga.type = "text/javascript"; ga.async = true;
                ga.src = ("https:" == document.location.protocol ? "https://" : "http://") + "stats.g.doubleclick.net/dc.js";
                var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ga, s);
        })();
</script>
                `,
                    }}
                />
                <Component {...pageProps} />
            </Provider>
        </>
    );
}
